import { render, staticRenderFns } from "./ArterList.vue?vue&type=template&id=4a6ddac8&scoped=true&"
import script from "./ArterList.vue?vue&type=script&lang=js&"
export * from "./ArterList.vue?vue&type=script&lang=js&"
import style0 from "./ArterList.vue?vue&type=style&index=0&id=4a6ddac8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ddac8",
  null
  
)

export default component.exports